---
date: 2022-04-23
title: BugFix on level handling
---

The syntax to use a range on the level tag `level=1-3` is now supported. Previously, only the syntax with semicolon `level=1;2;3` was.
